import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { OproepHistorie } from '../dto/oproep-historie';
import { CrudService } from '@mango/core';
import { map } from 'rxjs/operators';
import { DocumentDownloadResponse } from './projectregel.service';
import { oproepBijlage } from '../dto/oproepbijlage';

@Injectable({ providedIn: 'root' })
export class OproepHistorieService extends CrudService<OproepHistorie> {

    constructor(injector: Injector) { super(OproepHistorie, injector); }

    GenereerBijlage(oproephistorie: OproepHistorie) {
        let query: string = `api/dto/oproephistorie/GenereerBijlage?Id=${oproephistorie.id}`;

        return this.http.post(query, null).pipe(map(x => x as OproepHistorieResponse));

    }

    VerstuurOproep(oproephistorie: OproepHistorie[]) {
                
        var opB = new oproepBijlage();
        opB.oproephistorie = oproephistorie;
                
        let query: string = `api/dto/oproephistorie/VerstuurBijlage`;
        
        return this.http.post(query, opB).pipe(map(x => x as OproepHistorieResponse));

    }

    OproepHistorieOpschonen() {
                
        let query: string = `api/dto/oproephistorie/OproepHistorieOpschonen`;
        
        return this.http.post(query, null).pipe(map(x => x as OproepHistorieResponse));

    }


    SetMailDatum(oproephistorie: OproepHistorie) {
        let query: string = `api/dto/oproephistorie/SetMailDatum?Id=${oproephistorie.id}`;

        return this.http.post(query, null).pipe(map(x => x as OproepHistorieResponse));

    }

    DownloadOproep(id: number) {

        let query: string = `api/dto/projectregel/DownloadOproep?oproepId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }
}


export class OproepHistorieResponse {
    successful: boolean;
    message: string;
}
